import { ProfileImprovement } from "@/@types";

export const useProfileImprovement = (obj: ProfileImprovement) => {
  const values = Object.values(obj);
  const concludedCount = values.filter((value) => value === true).length;
  const totalCount = values.length;
  const percentage = (concludedCount / totalCount) * 100;
  return {
    percentage,
    concludedCount,
    totalCount,
  };
};
